import CardSection from "../../../../conponents/CardSection/CardSection";
import TextAreaField from "../../../../conponents/textAreaField/TextAreaField";

const ExpenseDescriptionSection = ({

    values,

    errors,

    touched,

    handleChange,

    handleBlur,

}) => {

    return (

        <CardSection title="توضیحات">

            <TextAreaField

                id="description"

                name="description"

                label="توضیحات"

                // rows={4}

                placeholder="در صورت نیاز توضیحی درباره این هزینه ثبت کنید..."

                value={values.description}

                error={errors.description}

                touched={touched.description}

                onChange={handleChange}

                onBlur={handleBlur}

            />

        </CardSection>

    );

};

export default ExpenseDescriptionSection;